import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { set } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { getBem } from 'umg-ember-backend/utils/get-bem';
import { translate } from 'umg-ember-backend/utils/intl';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class UiFormFieldCheckbox extends Component {
  // Services
  @service intl;

  // Getter and setter
  get offLabelString() {
    return this._getLabel('off', this.args.offLabel);
  }

  get onLabelString() {
    return this._getLabel('on', this.args.onLabel);
  }

  get style() {
    return this.args.style ?? 'switch';
  }

  // Functions
  onClick = () => {
    if (!this.args.isDisabled) {
      if (this.args.onChange) {
        this.args.onChange(!this.args.isChecked);
      } else {
        set(this.args.model, this.args.property, !this.args.isChecked);
      }
    }
  };

  _getLabel = (key, label) => {
    const lookups = [`forms.${this.args.recordType}`, 'forms.defaults'];

    return translate.call(this, label, lookups, {
      append: `options.${this.args.property}.${key}`,
      silent: true,
    });
  };

  // Template
  <template>
    <div
      class={{bem
        (hash is-disabled=@isDisabled is-checked=@isChecked style=this.style)
      }}
      role='button'
      {{on 'click' this.onClick}}
      ...attributes
    >
      {{#if this.offLabelString}}
        <div class={{bem 'label' (hash off=true)}}>
          {{this.offLabelString}}
        </div>
      {{/if}}
      <div class={{bem 'toggle'}}></div>
      {{#if this.onLabelString}}
        <div class={{bem 'label' (hash on=true)}}>
          {{this.onLabelString}}
        </div>
      {{/if}}
    </div>
  </template>
}
